import React, {Component} from "react"

import {Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"

class EmptyRegions extends Component {
  render() {
    return (
      <Body>
        <FormattedMessage id="admin.reporting.emptyData.regions" />
      </Body>
    )
  }
}

export default EmptyRegions
